import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");
  const [eCalendar] = useParameter<number[]>("@e_calendar");
  const [crop_calendar] = useParameter<number[]>("@e_crop_calendar");
  const [countries] = useParameter<number[]>("@e_countries_net_trade");
  const [commodities, setCommodities] = useParameter<number[]>("@commodities");
  const [business, setBusiness] = useParameter<number>("@business-units");
  const [commDisplay, setCommDisplay] = useParameter<string[]>("@commodities_display");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@business-units": business,
      "@commodities": commodities,
      "@commodities_display": commDisplay,
      "@calendar": calendar,
      "@e_calendar": eCalendar,
      "@countries_net_trade": countries,
      "@crop_calendar": crop_calendar,
    });
  }, [title, subtitle, business, eCalendar, commDisplay, calendar, commodities, crop_calendar, countries, setParameters]);

  const applyParameters = useCallback(
    (parameters: ApplyParameters) => {
      setBusiness((parameters["@business-units"].value as string[]).map(Number)[0]);
      setCommodities((parameters["@commodities"].value as string[]).map(Number));
      setCommDisplay(parameters["@commodities_display"].value as string[]);
    },
    [setBusiness, setCommodities, setCommDisplay]
  );

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
